import React from 'react';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/button';
import { packages } from '../mock/mockData';

export const Packages = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="packages" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">Service Packages</h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Choose the perfect package for your garage cleanout needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {packages.map((pkg) => (
            <div
              key={pkg.id}
              className={`relative bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 ${
                pkg.popular ? 'ring-2 ring-blue-500' : ''
              }`}
            >
              {pkg.popular && (
                <div className="absolute top-0 right-0 bg-blue-600 text-white px-4 py-1 text-sm font-semibold rounded-bl-lg flex items-center space-x-1">
                  <Star className="h-4 w-4 fill-current" />
                  <span>Popular</span>
                </div>
              )}

              <div className="p-8">
                <div className="mb-6">
                  <h3 className="text-2xl font-bold text-slate-900 mb-1">{pkg.name}</h3>
                  <p className="text-blue-600 font-semibold mb-4">{pkg.subtitle}</p>
                  <div className="text-3xl font-bold text-slate-900">{pkg.price}</div>
                </div>

                <div className="mb-6">
                  <p className="text-sm text-slate-600 italic">{pkg.perfectFor}</p>
                </div>

                <div className="space-y-3 mb-6">
                  <p className="text-sm font-semibold text-slate-700">Includes:</p>
                  {pkg.includes.slice(0, 5).map((item, idx) => (
                    <div key={idx} className="flex items-start space-x-2">
                      <Check className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-slate-600">{item}</span>
                    </div>
                  ))}
                  {pkg.includes.length > 5 && (
                    <p className="text-sm text-slate-500 italic">+ {pkg.includes.length - 5} more features</p>
                  )}
                </div>

                <Button
                  onClick={scrollToContact}
                  className={`w-full ${
                    pkg.popular
                      ? 'bg-blue-600 hover:bg-blue-700 text-white'
                      : 'bg-slate-100 hover:bg-slate-200 text-slate-900'
                  }`}
                >
                  Get Quote
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* What's Always Included */}
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center">What's Always Included</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              'Fuel and dump fees',
              'Basic protective floor covering',
              'Liability insurance coverage',
              'Transparent pricing with no hidden fees',
              'Free onsite estimate',
              'Clean, uniformed, background-checked staff'
            ].map((item, idx) => (
              <div key={idx} className="flex items-start space-x-3">
                <Check className="h-5 w-5 text-blue-600 flex-shrink-0 mt-1" />
                <span className="text-slate-700">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
